// extracted by mini-css-extract-plugin
module.exports = {"input":"TextInput_input__3uxFX","label":"TextInput_label__388j7"};